var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 32,
    y: 32,
    fill: "#579FD7",
    opacity: 0.01,
    rx: 16,
    transform: "rotate(180 32 32)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    fillRule: "evenodd",
    d: "M16 7c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.038-9-9-9zm.105 14.427c-.424.079-.929.173-1.23.198-.366.03-.71-.179-.921-.48-.211-.3-.262-.684-.136-1.03l1.7-4.677H13.75c-.002-.975.73-1.692 1.665-1.967.446-.131 1.277-.311 1.71-.284.26.017.71.18.921.48.211.3.262.685.136 1.03l-1.7 4.678h1.768c0 .974-.704 1.805-1.665 1.965-.129.021-.297.053-.48.087zM16 11.5c0 .621.504 1.125 1.125 1.125s1.125-.504 1.125-1.125-.504-1.125-1.125-1.125S16 10.879 16 11.5z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.298d57c1.svg";
export { ForwardRef as ReactComponent };